<template>
    <div class="fixed-right" :style="{ top: `${storeCommon.headerHeight}px` }">
        <p class="fixed-right-item" @click="jumpToRule">规则</p>
        <p class="fixed-right-item" @click="jumpToDetail">明细</p>
    </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import { openWebview } from '@q-front-npm/jsbridge';
import { useStoreCommon } from '@qm-activity/common/store/common';
import { ruleLink } from '@/assets/ts/const';
const storeCommon = useStoreCommon();
const jumpToRule = () => {
    openWebview(ruleLink);
};
const jumpToDetail = () => {
    openWebview(`https://api-marathon.wtzw.com/h5/activity/freereaderMarathon2026/sidePanel/details?full_screen=3`);
};
</script>
<style lang="scss" scoped>
.fixed-right {
    position: absolute;
    right: 20px;
    padding-top: 104px;
    &-item {
        margin-bottom: 20px;
        width: 56px;
        height: 56px;
        background: rgba(88, 88, 88, 0.2);
        font-size: 20px;
        color: #ffffff;
        line-height: 56px;
        border-radius: 50%;
        text-align: center;
    }
}
</style>
